import { ThemeChoices } from '../../pages/systemTheme/types'
import { db } from '../../services/db'

export const useTheme = () => {
  const registerTheme = async (data: ThemeChoices) => {
    await db.theme.clear()

    await db.theme.add({ theme: data })
  }

  const getTheme = async () => {
    const theme = await db.theme.toArray()

    return theme.length ? theme[0] : null
  }

  return {
    register: registerTheme,
    getData: getTheme,
  }
}
